export enum CompanyStatus {
  None = 0,
  Active = 1,
  Implementation = 2,
  Disabled = 3
}

export const getCompanyStatusLabel = (status?: CompanyStatus) => {
  switch (status) {
    case CompanyStatus.None:
      return 'None';
    case CompanyStatus.Active:
      return 'Active';
    case CompanyStatus.Implementation:
      return 'Implementation';
    case CompanyStatus.Disabled:
      return 'Disabled';
    default:
      return undefined;
  }
};
